import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProvisioningService } from '../../../services/provisioning/provisioning.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// the caretaker gets one of the standard notes (reports group on these), with
// 'Other' opening a free-text box.
const CARETAKER_REMARKS = [
  'Match Relationship Properly',
  'Check ID Properly',
  'Old Age Group-Take Proper care',
  'Worker Present',
  'Female Only Booking',
];

// provision (lock + confirm, end-to-end) a requisition. before deciding, the
// operator sees the whole booking: guests, soft-allocated rooms, and the
// family's previous stays. data = { bookingId, category }.
@Component({
  selector: 'app-provision-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, LoaderComponent],
  templateUrl: './provision-dialog.component.html',
  styleUrls: ['./provision-dialog.component.scss', '../../../../common-style/dropdown.scss', '../../../../common-style/ac-dialog.scss'],
})
export class ProvisionDialogComponent implements OnInit {
  form: FormGroup;
  isLoading: boolean = false;
  categories = ['Regular', 'Utsav'];
  caretakerRemarks = CARETAKER_REMARKS;

  detail: any = null;
  guests: any[] = [];
  rooms: any[] = [];
  previousStays: any[] = [];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ProvisionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { bookingId: number; category: string },
    private provisioningService: ProvisioningService,
    private toastService: ToastService
  ) {
    this.form = this.fb.group({
      category: [this.data.category === 'Utsav' ? 'Utsav' : 'Regular', Validators.required],
      operatorProvisionRemark: [''],
      caretakerChoice: [''],
      caretakerOther: [''],
    });
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.provisioningService.searchById(this.data.bookingId).subscribe({
      next: (res: any) => {
        this.detail = res?.data || null;
        this.guests = this.detail?.guests || [];
        this.rooms = this.detail?.provisionDetails || [];
        this.previousStays = (this.detail?.previousStays || []).slice(0, 5);
        this.isLoading = false;
      },
      error: () => {
        // the operator can still provision without the preview
        this.isLoading = false;
      },
    });
  }

  guestKey(g: any): string {
    return String(g?.guestRowId ?? '');
  }

  stayKey(s: any): string {
    return String(s?.requisitionId ?? '');
  }

  roomKey(r: any): string {
    return `${r?.guestHouseName ?? ''}-${r?.roomCode ?? ''}`;
  }

  submit(): void {
    const v = this.form.value;
    const caretakerRemark = v.caretakerChoice === 'Other' ? v.caretakerOther : v.caretakerChoice;
    const payload = {
      category: v.category,
      operatorProvisionRemark: v.operatorProvisionRemark || '',
      operatorRemarkToCaretaker: caretakerRemark || '',
    };
    this.isLoading = true;
    this.provisioningService.provision(this.data.bookingId, payload).subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Requisition provisioned.');
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Provisioning failed.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
